export default "__VITE_ASSET__sZvuyEq3__"